export const uiConfig = {
  appLogo: '/sward-logo.svg',
};
